import { render, staticRenderFns } from "./SupplierTypelist.vue?vue&type=template&id=8f9713a2"
import script from "./SupplierTypelist.vue?vue&type=script&lang=js"
export * from "./SupplierTypelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports